import {
  useCallback,
  useEffect,
  useState,
} from 'react'

import {
  Outlet,
} from 'react-router-dom'

import type {
  MeResponse,
} from '../../types/me'

import {
  AdminHeader,
} from './AdminHeader'

import {
  AdminSidebar,
} from './AdminSidebar'

type AdminLayoutProps = {
  me: MeResponse
}

const STORAGE_KEY =
  'kraken-admin-sidebar-collapsed'

export function AdminLayout({
  me,
}: AdminLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] =
    useState(() => {
      try {
        return (
          window.localStorage.getItem(
            STORAGE_KEY,
          ) === '1'
        )
      } catch {
        return false
      }
    })

  const [mobileSidebarOpen, setMobileSidebarOpen] =
    useState(false)

  useEffect(() => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        sidebarCollapsed
          ? '1'
          : '0',
      )
    } catch {
      // localStorage может быть недоступен.
    }
  }, [sidebarCollapsed])

  const closeMobileSidebar =
    useCallback(() => {
      setMobileSidebarOpen(false)
    }, [])

  return (
    <div
      className={[
        'admin-app',
        sidebarCollapsed
          ? 'admin-app--collapsed'
          : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <AdminSidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={
          closeMobileSidebar
        }
      />

      <div className="admin-app__workspace">
        <AdminHeader
          me={me}
          sidebarCollapsed={
            sidebarCollapsed
          }
          onToggleSidebar={() =>
            setSidebarCollapsed(
              (current) =>
                !current,
            )
          }
          onOpenMobileSidebar={() =>
            setMobileSidebarOpen(true)
          }
        />

        <main className="admin-app__content">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
